/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourcePoolRequestApprovalState } from './resourcePoolRequestApprovalState';


export interface ResourcePoolRequestPatchSpec { 
    preferred_resource_id?: string;
    request_status: ResourcePoolRequestApprovalState;
}
export namespace ResourcePoolRequestPatchSpec {
}


